import React from "react";

function LoaderComponent() {
  return (
    <div className="loader-wrapper">
      <div className="organic-loader">
        <div className="leaf"></div>
        <div className="leaf"></div>
        <div className="leaf"></div>
      </div>
      <p className="loader-text">Growing something natural for you…</p>
    </div>
  );
}

export default LoaderComponent;
